import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function DomainBasicInfoComponent ({handleInnerFormChange, selectedDomain,parentDomain}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedDomain?.Name}
          />
        
        <InputContainer

label="Core Domain"

onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
        'IsCoreDomain',

      )
}}
type="checkbox"
value={selectedDomain?.IsCoreDomain}
/>
<InputContainer

label="SubDomain"

onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
        'IsSubDomain',

      )
}}
type="checkbox"
value={selectedDomain?.IsSubDomain}
/>
{selectedDomain?.IsSubDomain === true &&
        <InputContainer
        label="Parent Domain"
        labelField="Name"
        list={parentDomain}
        onValueChange={(event: any, newValue: any) => {
            handleInnerFormChange(
         event.target.value,
        'ParentDomainId'
        );
        }}
        optionName="Choose Parent Domain"
        type="select"
        value={selectedDomain?.ParentDomainId}
        valueField="Id"
        />
  }
   <InputContainer

label="Code"

onValueChange={(event: any) => {
    handleInnerFormChange(
        event.target.value,
       'Code'
       );
}}
type="text"
value={selectedDomain?.Code}
/>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}